import { useEffect, useState } from "react";
import { useAlert } from "../contexts/AlertContext";
import "./alert.css";

const Alert = () => {
  const { alerts, removeAlert } = useAlert();

  return (
    <div className="alert-container">
      {alerts.map((alert) => (
        <AlertItem key={alert.id} alert={alert} onRemove={removeAlert} />
      ))}
    </div>
  );
};

const AlertItem = ({ alert, onRemove }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    const timer = setTimeout(() => setIsVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => onRemove(alert.id), 300);
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case "success":
        return "🎵"; // Musical note for success
      case "error":
        return "💫"; // Star for error (softer than harsh symbols)
      case "warning":
        return "🌸"; // Flower for warning
      case "info":
      default:
        return "🎼"; // Musical staff for info
    }
  };

  const getAlertEmoji = (type) => {
    switch (type) {
      case "success":
        return "🌻"; // Sunflower
      case "error":
        return "🌹"; // Rose
      case "warning":
        return "🌷"; // Tulip
      case "info":
      default:
        return "🌼"; // Daisy
    }
  };

  return (
    <div
      className={`alert alert-${alert.type} ${
        isVisible ? "alert-visible" : ""
      } ${isExiting ? "alert-exiting" : ""}`}
    >
      <div className="alert-content">
        <div className="alert-icon-section">
          <span className="alert-main-icon">{getAlertIcon(alert.type)}</span>
          <span className="alert-flower">{getAlertEmoji(alert.type)}</span>
        </div>

        <div className="alert-message">{alert.message}</div>

        <button
          onClick={handleClose}
          className="alert-close-btn"
          aria-label="Close alert"
        >
          ✕
        </button>
      </div>

      {/* Decorative elements */}
      <div className="alert-sparkles">
        <span className="sparkle sparkle-1">✨</span>
        <span className="sparkle sparkle-2">⭐</span>
        <span className="sparkle sparkle-3">💫</span>
      </div>
    </div>
  );
};

export default Alert;
